import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SwitchTransition, CSSTransition } from 'react-transition-group';

import { WindowProxy } from '@sm360/widget-commons-core-services';

import './Wizard.scss';

class Wizard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            stepIndex: props.startingStepIndex || 0,
        };

        this.goNextStep = this.goNextStep.bind(this);
        this.goPreviousStep = this.goPreviousStep.bind(this);
        this.goToStep = this.goToStep.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.startingStepIndex !== this.props.startingStepIndex) {
            this.goToStep(nextProps.startingStepIndex);
        }

        return nextState.stepIndex !== this.state.stepIndex || nextProps.steps !== this.props.steps;
    }

    goPreviousStep() {
        this.goToStep(this.state.stepIndex - 1);
    }

    goNextStep() {
        this.goToStep(this.state.stepIndex + 1);
    }

    goToStep(index) {
        let indexToGo = index;
        if (indexToGo < 0) {
            indexToGo = 0;
        } else if (this.props.steps.length <= index) {
            indexToGo = this.props.steps.length - 1;
        }
        this.setState(
            {
                stepIndex: indexToGo,
            },
            () => {
                const windowProxy = WindowProxy.get();
                if (windowProxy) {
                    const parent =
                        !!this.props.parentSelector && windowProxy.document.querySelector(this.props.parentSelector);
                    if (parent) {
                        parent.scrollIntoView(true);
                    } else {
                        windowProxy.document.getElementById('Wizard--body').scrollIntoView(true);
                    }
                }
                this.props.onStepTransition();
            }
        );
    }

    render() {
        const props = {
            goNextStep: this.goNextStep,
            goPreviousStep: this.goPreviousStep,
            stepIndex: this.state.stepIndex,
        };
        return (
            <div className="Wizard--body" id="Wizard--body">
                <SwitchTransition mode="out-in">
                    <CSSTransition
                        timeout={400}
                        key={`step-${this.state.stepIndex}`}
                        addEndListener={(node, done) => node.addEventListener('transitionend', done, false)}
                        classNames="fade"
                    >
                        <div className="Wizard--step" key={this.state.stepIndex}>
                            {this.props.steps[this.state.stepIndex] &&
                                this.props.steps[this.state.stepIndex]({ ...props })}
                        </div>
                    </CSSTransition>
                </SwitchTransition>
            </div>
        );
    }
}

Wizard.defaultProps = {
    onStepTransition: () => {},
    startingStepIndex: 0,
    parentSelector: '',
};

Wizard.propTypes = {
    steps: PropTypes.arrayOf(PropTypes.func).isRequired,
    onStepTransition: PropTypes.func,
    startingStepIndex: PropTypes.number,
    parentSelector: PropTypes.string,
};

export { Wizard };

Wizard.displayName = 'Wizard';

export default Wizard;
